var PressReleases = (function () {
  

  Utility.log('PressReleases.js loaded');

  var pressReleaseClass = 'article.press-releases-page';
  var $pressReleases = $(pressReleaseClass);

  var debounce;

  function init() {
    $pressReleases.each(function (i, el) {
      // Set up Listeners.
      $(el).on('selectBoxOptionChanged', submitFEFDebounce);

      // Init classes on select options.
      $('.acr-select-box-options li', $(el)).removeClass('selected');
      $('.acr-select-box-options', $(el)).each(function (idx, elem) {
        $('li', $(elem)).first().addClass('selected');
      });

      // Set min height so that custom select boxes won't get cut off
      setMinHeight(el);
      $(el).on('selectBoxOptionShown', setMinHeightEvent);
      $(el).on('selectBoxOptionHidden', setMinHeightEvent);

      _attachResize();
    });
  }

  function submitFEFDebounce(e, inputElem) {
    e.stopPropagation();
    clearTimeout(debounce);
    debounce = setTimeout(submitFormElectionFilter.bind(this, e, inputElem), 250);
  }

  function submitFormElectionFilter(e, inputElem, selectBoxName, selectBoxValue) {
    e.stopPropagation();
    // update correct form element with new value.
    $('form[name="formElectionFilter"] input[name="' + selectBoxName + '"]',
      $(this)).val(selectBoxValue);
    // get all values from form and submit.
    var year = $('form[name="formElectionFilter"] input[name="year"]', $(this)).val();
    var keywords = $('form[name="formElectionFilter"] input[name="keywords"]', $(this)).val();
    var rssFeedCategory = $('form[name="formElectionFilter"] #select-list-category > ul > li.selected > span', $(this)).data('rssfeedcategory');
    var pageNum = $('form[name="formElectionFilter"] input[name="pageNum"]', $(this)).val();
    if (window.location.hostname === 'localhost') {
      console.log('Localhost: simulate call to getViewData(' + year + ', ' + keywords + ', ' + rssFeedCategory + ', ' + pageNum + ')');
    } else {
      try {
        // this function should already exist in C# template.
        getViewData(year, keywords, rssFeedCategory, pageNum);
      } catch (e) {
        console.log(e);
      }
    }
  }

  function setMinHeightEvent(evt) {
    setMinHeight(evt.currentTarget);
  }

  function setMinHeight(el) {
    var $el = $(el);
    var prHeight = $el.height();

    var maxSelectBoxHeight = 0;
    $('.acr-select-box', $el).each(function (i, el) {
      if ($(el).height() > maxSelectBoxHeight) {
        maxSelectBoxHeight = $(el).height();
      }
    });

    var maxSelectOptionsHeight = 0;
    var optionExpanded = false;
    $('.acr-select-box-options', $el).each(function (i, el) {
      if ($(el).height() > maxSelectOptionsHeight) {
        maxSelectOptionsHeight = $(el).height();
      }
      if ($(el).attr('aria-expanded') === 'true') {
        optionExpanded = true;
      }
    });

    var prMinHeight = 0;
    if (optionExpanded) {
      prMinHeight = prHeight - maxSelectBoxHeight + maxSelectOptionsHeight;
    }
    $el.css('min-height', prMinHeight + 'px');
  }

  function _attachResize() {
    $(window).on('resize', _onResize);
  }

  function _onResize(event) {
    clearTimeout(debounce);
    debounce = setTimeout(_resize, 250);
  }

  function _resize() {
    $pressReleases.each(function (i, el) {
      setMinHeight(el);
    });
  }

  return {
    init: init,
  };
}());

